import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { X } from "react-feather";
import { TabService } from "../../../../services/sale/tabService.ts";

export default function TabSelectModal({ isOpen, onClose, onSelect }) {
  const [tabs, setTabs] = useState([]);
  const [search, setSearch] = useState("");

  useEffect(() => {
    if (isOpen) {
      loadTabs();
    }
  }, [isOpen]);

  const loadTabs = async () => {
    try {
      const result = await TabService.getAllTabs();
      const openTabs = (result ?? []).filter((t) => !t.IsClosed && !t.IsVoided);
      setTabs(openTabs);
    } catch (err) {
      console.error("Failed to load tabs", err);
      setTabs([]);
    }
  };

  if (!isOpen) return null;

  const filteredTabs = tabs.filter((t) => {
  const name = (t.TabName ?? "").toLowerCase();
  const account = (t.AccountName ?? "").toLowerCase();
  const term = search.toLowerCase();

  return name.includes(term) || account.includes(term);
});
  return (
    <div
      className="modal fade show d-block"
      style={{ backgroundColor: "rgba(0,0,0,0.6)", zIndex: 1055 }}
    >
      <div
        className="modal-dialog modal-md modal-dialog-centered"
        style={{ maxWidth: "750px", width: "100%" }}
      >
        <div className="modal-content">

          {/* HEADER */}
          <div className="modal-header p-4 border-0">
            <h5 className="modal-title">Open Tabs</h5>
            <button className="btn" onClick={onClose}>
              <X size={20} />
            </button>
          </div>

          {/* BODY */}
          <div className="modal-body p-4">

            {/* SEARCH */}
            <div className="table-top mb-3">
              <div className="search-set w-100 search-order">
                <div className="search-input w-100">
                  <input
                    type="text"
                    placeholder="Search..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    className="form-control form-control-sm formsearch w-100"
                  />
                  <button type="button" className="btn btn-searchset">
                    <i className="feather-search" />
                  </button>
                </div>
              </div>
            </div>

            {/* TAB LIST */}
            <div
              className="order-body"
              style={{ maxHeight: "60vh", overflowY: "auto" }}
            >
              {filteredTabs.length === 0 && (
                <p className="text-muted text-center py-3">No open tabs found</p>
              )}

              {filteredTabs.map((t) => (
                <div
                  key={t.TabID}
                  className="default-cover p-4 mb-4"
                  style={{
                    border: "1px solid #ddd",
                    borderRadius: "8px",
                    boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                    background: "#fff"
                  }}
                >

                  {/* BADGES */}
                  <div className="d-flex align-items-center justify-content-between mb-4">
                    <span
                      className="badge bg-secondary d-inline-block"
                      style={{ fontSize: "0.9rem", padding: "6px 10px" }}
                    >
                      {t.TabName ?? t.AccountName}
                    </span>

                    {t.TableNumber && (
                      <span
                        className="badge bg-secondary d-inline-block"
                        style={{ fontSize: "0.9rem", padding: "6px 10px" }}
                      >
                        {t.TableNumber}
                      </span>
                    )}
                  </div>

                  <div className="row">
                    {/* LEFT SIDE */}
                    <div className="col-sm-12 col-md-6 record mb-3">
                      <table>
                        <tbody>
                          <tr>
                            <td>Cashier</td>
                            <td className="colon">:</td>
                            <td>{t.StaffName}</td>
                          </tr>
                          <tr>
                            <td>Customer</td>
                            <td className="colon">:</td>
                            <td>{t.AccountName}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    {/* RIGHT SIDE */}
                    <div className="col-sm-12 col-md-6 record mb-3">
                      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "6px" }}>
                        <span style={{ whiteSpace: "nowrap" }}>
                          Date <span style={{ margin: "0 4px" }}>:</span>
                        </span>
                        <span style={{ whiteSpace: "nowrap" }}>
                          {t.DateOpened}
                        </span>
                      </div>

                      <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <span style={{ whiteSpace: "nowrap" }}>
                          Total <span style={{ margin: "0 4px" }}>:</span>
                        </span>
                        <span style={{ whiteSpace: "nowrap" }}>
                          <span className="text-success fw-bold me-4">
                            Paid: R{(t.AmountPaid ?? 0).toFixed(2)}
                          </span>
                          <span className="text-danger fw-bold">
                            Due: R{(t.AmountDue ?? 0).toFixed(2)}
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* SPACER */}
                  <div className="p-4 bg-light rounded mb-4" />

                  {/* OPEN BUTTON */}
                  <button
                    type="button"
                    className="btn btn-info w-100"
                    onClick={() => onSelect(t)}
                  >
                    Open
                  </button>

                </div>
              ))}
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

TabSelectModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
};
